"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 24 24",
    width: "24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m0 0h24v24h-24z"
  })), /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)",
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m8 12.71a.43.43 0 0 0 .3-.42v-2.23c0-.44 0-.9 1.79-.9h8.5v2.24a.41.41 0 0 0 .28.42.43.43 0 0 0 .5-.12l4.48-4.92a.42.42 0 0 0 0-.6l-4.46-4.93a.43.43 0 0 0 -.5-.11.4.4 0 0 0 -.28.41v2.24h-8.5c-2.78 0-4 2.47-4 4.92a6.48 6.48 0 0 0 1.38 3.87.4.4 0 0 0 .34.16z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m16.5 11.42a.4.4 0 0 0 -.49-.13.42.42 0 0 0 -.3.42v2.23c0 .44 0 .9-1.79.9h-8.54v-2.24a.41.41 0 0 0 -.28-.42.43.43 0 0 0 -.5.12l-4.47 4.93a.42.42 0 0 0 0 .6l4.47 4.92a.43.43 0 0 0 .5.11.4.4 0 0 0 .28-.41v-2.24h8.5c2.78 0 4-2.47 4-4.92a6.48 6.48 0 0 0 -1.38-3.87z"
  })));
};

exports["default"] = _default;